import React from "react";
import classes from "./ActiveInvestment.module.css";
import { Button, Heading, Text } from "components/common";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const ActiveInvestment = ({ positions }) => {
  let active_positions = positions.filter(
    (el) => el.status.toLowerCase() === "active"
  );
  const navigate = useNavigate();

  if (!active_positions?.length) {
    return (
      <section className={classes.wrapper}>
        <div className={classes.header}>
          <Heading lg semiBold>
            Active Investments (0)
          </Heading>
        </div>
        <div className={classes.emptyState}>
          <Text>You don't have any active investments yet.</Text>
          <Button
            onClick={() => {
              navigate("/investments-plan");
            }}
            primary
            className={classes.ctaButton}
          >
            Start New Investment
          </Button>
        </div>
      </section>
    );
  }

  const formatDate = (timestamp) => {

    console.log(timestamp)
    if (!timestamp) return '-';
    return new Date(timestamp * 1000).toLocaleDateString();
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <section className={classes.wrapper}>
      <div className={classes.header}>
        <Heading lg semiBold>
          Active Investments ({active_positions?.length})
        </Heading>
        <Button
          onClick={() => {
            navigate("/my-investments");
          }}
          transparent
          base
          className={classes.button}
        >
          See All
        </Button>
      </div>
      <div className={classes.tableContainer}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th className={classes.planIdColumn}>Plan ID</th>
              <th>Capital</th>
              <th>Reward/Cycle</th>
              <th>Withdrawn Profits</th>
              <th>Withdrawals</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Last Claim</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {active_positions.map((position, index) => (
              <tr key={index}>
                <td className={classes.planIdCell}>
                  <Link to={`/plan/${position.plan_id}`} className={classes.planIdLink}>
                    <span className={classes.planIdPrefix}>#</span>
                    {position.plan_id}
                  </Link>
                </td>
                <td className={classes.amountCell}>{formatCurrency(position.capital)}</td>
                <td className={classes.amountCell}>{formatCurrency(position.reward_per_cycle)}</td>
                <td className={classes.amountCell}>{formatCurrency(position.total_profits_withdrawn)}</td>
                <td className={classes.centerCell}>{position.num_profit_withdrawal}</td>
                <td>{formatDate(position.created_at)}</td>
                <td>{formatDate(position.end_date)}</td>
                <td>{position.last_profit_claim_date || 'N/A'}</td>
                <td>
                  <span className={classes[position.status.toLowerCase()]}>
                    {position.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ActiveInvestment;
